export const enUs = {
    '微信验证码': 'WECHAT',
    '账号密码': 'ACCOUNT',
    '用户名': 'username',
    '密码': 'password',
    '登 录': 'login',
    '邮箱验证码': 'Email verification code',
    '发送': 'send',
    '绑 定': 'bind',
    '微信二维码': 'Wechat QR Code',
    '用户名不能为空': 'The user name cannot be empty',
    '密码不能为空': 'The password cannot be empty',
    '邮箱不能为空': 'The email cannot be empty',
    '验证码不能为空': 'The verification code cannot be empty',
    '发送成功': 'Send a success'
}
